





















































import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'

@Component
export default class ComponentSolicitacaoCirurgiaActions extends Vue {
  @Prop({ required: false, default: 'Assinar e Enviar' }) saveForm
  @Prop({ required: false, default: 'Salvar e Continuar Depois' }) saveAndContinueLater
  @Prop({ required: false, default: 'Excluir solicitação' }) deleteLabel
  @Prop({ required: false, default: '' }) secondaryActionButtonLabel
  @Prop({ required: false, default: false }) disabledBtn: boolean
  @Prop({ required: false, default: true }) showSaveOrUpdate: boolean
  @Prop({ required: false, default: false }) secondaryActionButtonEnabled: boolean
  @Prop({ required: false, default: false }) secondaryActionButtonDisabled: boolean
  @Prop({ required: false, default: false }) showSaveForLater: boolean
  @Prop({ required: false, default: false }) showDelete: boolean
  @Prop({ required: false, default: false }) loadingSaveOrUpdate: boolean
  @Prop({ required: false, default: false }) loadingContinueLater: boolean
  @Prop({ required: false, default: false }) loadingDelete: boolean
  @Prop({ required: false, default: false }) secondaryActionLoading: boolean

  windowWidth: number = 0

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth + 15
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  update() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
